'use strict';

var Feature = require('../../motion/features/Feature.cjs');
var VisualElementDragControls = require('./VisualElementDragControls.cjs');
var noop = require('../../../../../../../motion-utils/dist/es/noop.cjs');

class DragGesture extends Feature.Feature {
    constructor(node) {
        super(node);
        this.removeGroupControls = noop.noop;
        this.removeListeners = noop.noop;
        this.controls = new VisualElementDragControls.VisualElementDragControls(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls } = this.node.getProps();
        if (dragControls) {
            this.removeGroupControls = dragControls.subscribe(this.controls);
        }
        this.removeListeners = this.controls.addListeners() || noop.noop;
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}

exports.DragGesture = DragGesture;
//# sourceMappingURL=index.cjs.map
